'use client'

import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'

const Finish = ({ setCurrentItem }) => {
  const { t } = useTranslation('commonAndroid')
  const textList = useMemo(
    () => [
      <>{t('Google drive')}</>,
      <>{t('Locations')}</>,
      <>{t('WhatsApp')}</>,
      <>{t('Google drive')}</>,
      <>{t('Photos videos')}</>,
      <>{t('Chrome history  bookmarks')}</>,
      <>{t('Contacts')}</>,
      <>{t('Trouble shooting')}</>
    ],
    [t]
  )
  console.log('123')

  return (
    <div className='flex flex-col items-center'>
      <h2 className='text-[24px] text-[#282938] font-[600] mx-auto text-center'>{t('Verify the target device')}</h2>
      <p className='mt-[24px] Dsm:mt-[6px] text-[16px] text-[#333333] w-[750px] Dsm:w-full mx-auto'>
        {t(
          'Congrats The target device has been successfully connected While the data is downloading please check all backup settings on the target phone to ensure you can make full use of Msafely'
        )}
      </p>
      <p className='mt-[18px] Dsm:mt-[12px] mb-[37px] Dsm:mb-[31px] w-[520px] Dsm:w-full text-[16px] text-[#999999]'>
        {t(
          'The entire process may take 35 minutes on the target phone Please check whether backup is enabled for the app data you want to monitor'
        )}
      </p>
      <div className='w-[520px] Dsm:w-full text-[18px] Dsm:text-[16px] rounded-[6px] bg-[#F4F6FC] px-[18px] py-[6px]'>
        <ul className='text-[#282938]'>
          {textList.map((item, i) => (
            <li key={i} className='flex items-center my-[2px] Dsm:my-[1px]'>
              <div className='w-[5px] h-[5px] Dsm:w-[4px] Dsm:h-[4px] rounded-[50%] bg-[#282938]'></div>&ensp;{item}
            </li>
          ))}
        </ul>
      </div>
      <button
        className='w-[400px] Dsm:w-[calc(100%-34px)] h-[64px] Dsm:h-[48px] bg-[#FFCF55] text-[20px] Dsm:text-[16px] text-[#1B1C2B] rounded-[41px] mt-[45px]'
        onClick={() => setCurrentItem('Google drive')}
      >
        {t('Next')}
      </button>
    </div>
  )
}

export default Finish
